// Shared utility functions for string transforms and file operations
// FEATURE: zen utility library for code generation helpers
import * as fs from "fs";

export const APP_SLUG_SQL = "app_slug";
export const APP_SLUG_JS = "appSlug";
export const GENERATED_FILE_BANNER = [
  "//////////////////////////////////////////////////////////////////////////////////////////////",
  "// DO NOT MODIFY THIS FILE                                                                  //",
  "// Generated by scripts/zen from Drizzle schema.                                            //",
  "//////////////////////////////////////////////////////////////////////////////////////////////",
  "",
  "/* eslint-disable */",
];

export function emitGeneratedFileBanner(): string[] {
  return [...GENERATED_FILE_BANNER];
}

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function toPascalCase(s: string): string {
  return s
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map(capitalize)
    .join("");
}

export function uncapitalize(s: string): string {
  return s.charAt(0).toLowerCase() + s.slice(1);
}

export function esc(s: string): string {
  return JSON.stringify(s);
}

export function getDrizzleTableName(table: unknown): string {
  return (table as Record<symbol, unknown>)[Symbol.for("drizzle:Name")] as string;
}

export function writeFileIfChanged(filePath: string, content: string): boolean {
  if (fs.existsSync(filePath) && fs.readFileSync(filePath, "utf-8") === content) {
    return false;
  }

  fs.writeFileSync(filePath, content, "utf-8");
  return true;
}
